import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const instructionsSlice = createSlice({
  name: "instructions",
  initialState,
  reducers: {
    setInstructions: (state, action) => {
      return { instructions: action.payload };
    },
    clearInstructions: (state)=>{
      return {instructions: ""}
    }
    
  },
});

export const instructionsReducer = instructionsSlice.reducer;
export const { setInstructions, clearInstructions} = instructionsSlice.actions;
// export default reducer;
